module.exports = __webpack_public_path__ + "static/media/0_2019_07_01-2.79f6d29f.jpg";